import React, { useEffect, useState } from "react";
import loadable from "@loadable/component";
import { useInView } from "react-intersection-observer";

const ReactTourismRating01 = loadable(() =>
	import("@micado-digital/react-tourism-rating/ReactTourismRating01")
);

const Ratings = ({ headlineCategories, headlineSources }) => {
	const { REACT_APP_PATH } = process.env;
	const [isInView, setIsInView] = useState(false);
	const [ref, inView] = useInView({ threshold: 1 });

	useEffect(() => {
		if (inView) {
			setIsInView(true);
		}
	}, [inView]);

	let providerID = 125;

	try {
		const x = document
			.querySelector("mt-layout-provider")
			.querySelector(`template[is="component-data-basic"]`);
		const data = JSON.parse(x.content.textContent);
		providerID = data.id;
	} catch (error) {}

	return (
		<div ref={ref}>
			{isInView && (
				<ReactTourismRating01
					headlineCategories={headlineCategories}
					headlineSources={headlineSources}
					lang={document.documentElement.lang ? document.documentElement.lang : "de"}
					providerID={providerID}
					showReviews={false}
					unit="points"
					url={`${REACT_APP_PATH}/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListRatings.api`}
				/>
			)}
		</div>
	);
};

export default Ratings;
